export const removePanelChangeFromQuiz = (config) => {
      const {annotations} = config;
      const quizAndActivitiesPanelAnnotations = annotations.filter(annotation => annotation.type === "quiz" || annotation.type === 'activitiespanel');
      const notQuizAnnotations = annotations.filter(annotation => annotation.type !== "quiz" && annotation.type !== 'activitiespanel');
  
      // Samples A and B don't include 'changes' key, 
      // this key will be added dynamically, since it includes a
      // hashcode that will be different for every video
      const stringifiedVariationSampleA = {
          conditions: [
              {
                  state: "orientation",
                  value: "portrait",
                  assertion: "equal"
              },
              {
                  state: "deviceType",
                  value: "mobile",
                  assertion: "equal"
              }]
      }
      const stringifiedVariationSampleB = {
          conditions: [
              {
                  state: "viewportWidth",
                  value: 769,
                  assertion: "lessThan"
              }]
          }
      
      const stringifiedVariationSampleC = {
              conditions: [
              {
                  state: "orientation",
                  value: "portrait",
                  assertion: "equal"
              },
              {
                  state: "deviceType",
                  value: "mobile",
                  assertion: "equal"
              }],
              changes: {
                  mode: "invisible"
              }
          }
      
      const stringifiedVariationSampleD = {
              conditions: [
              {
                  state: "viewportWidth",
                  value: 769,
                  assertion: "lessThan"
              }],
              changes: {
                  mode: "invisible"
              }  
          }
  
        const getNewVariations = (variations) => {
          return variations.filter((variation) => {
              const {changes} = variation
              // Here is where 'changes' object is added to samples A and B
              // the shape of the variation object for sample A and B will allways be the same,
              // so it's safe to add changes this way.
              stringifiedVariationSampleA.changes = changes
              stringifiedVariationSampleB.changes = changes
  
              const shouldIncludeVariation = 
              (JSON.stringify(variation) !== JSON.stringify(stringifiedVariationSampleA)) &&
              (JSON.stringify(variation) !== JSON.stringify(stringifiedVariationSampleB)) &&
              (JSON.stringify(variation) !== JSON.stringify(stringifiedVariationSampleC)) &&
              JSON.stringify(variation) !== JSON.stringify(stringifiedVariationSampleD)
          
              return shouldIncludeVariation
          })
        }
        
        const newQuizzes = quizAndActivitiesPanelAnnotations.map((quiz) => {
          const {variations} = quiz
          const newVariations = getNewVariations(variations)
  
          return {
              ...quiz,
              variations: newVariations
          }
        })
  
        const newAnnotations = [...notQuizAnnotations,...newQuizzes]
        const newConfig = {
          ...config,
          annotations: newAnnotations
        }
  
      return newConfig
  }